import styled from "styled-components";

const LoadingBackground = styled.div`
  position:absolute;
  z-index:9000;
  background-color:#00000036;
  left:0;
  width: 100%;
  height: 100%;
  align-content: center;

  text-align: center;
  top: 0;
  bottom: 0;
  margin: auto;
  img {
    width: 50%;
    max-width: 15rem;
  }
`;
function Loading() {
  return (
    <LoadingBackground>
      <img src="/image/Spinner.svg" alt="loading"/>
      <div>Loading...</div>
    </LoadingBackground>
  );
}

export default Loading;